import React, { useEffect, useState } from "react";
import axios from "axios";
import {Link} from "react-router-dom";

const BlogC = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOG;
        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => setBlogs(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, []);

    return (
        // <pre>{JSON.stringify(rooms, null, 2)}</pre>

        <article className="row blog_item"> {/* Ensure a wrapping parent div */}
            {blogs.map((blog, index) => {
                return (
                    <div className="col-md-6 col-lg-6 mb-4 mb-md-0 my-4" key={index}>
                        <div className="blog_post">
                            <img src={blog.image} alt={blog.title} />
                            <div className="blog_details">
                                <Link className="nav-link" to={`/blog/${blog.slug}`}><h2>{blog.title}</h2></Link>
                                <p>{blog.short}</p>
                                <Link className="button nav-link" to={`/blog/${blog.slug}`}>View More</Link>
                            </div>
                        </div>
                    </div>
                );
            })}
        </article>

    );
};

export default BlogC;